import * as excess from "web-excess";
import type { TrackingProperties } from "web-excess";

let initialized = false;

export const init = ({
  debug,
  loggedOutUuid,
  userAgent,
  userId,
}: {
  debug: boolean;
  loggedOutUuid: string | undefined;
  userAgent: string;
  userId: number | undefined;
}) => {
  // Init Excess
  excess.init();
  excess.setDebug(debug);

  // Identify user
  const distinctId = `${userId}` ?? loggedOutUuid;
  if (distinctId) {
    excess.identify(distinctId);
  }
  if (userId) {
    excess.register({
      user_id: `${userId}`,
    });
  }

  // Register super properties
  excess.register({
    user_agent: userAgent,
  });

  // Flag Excess as initialized
  initialized = true;
};

export const track = async (
  eventName: string,
  properties: TrackingProperties,
) => {
  if (!initialized) {
    throw Error(`Excess not initialized, can't track ${eventName} yet`);
  }
  await new Promise<void>(resolve => {
    excess.track(eventName, properties, resolve);
  });
};
